<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import VueApexCharts from "vue-apexcharts";
import Calendar from "primevue/calendar";
import { api } from "@/state/services";
import RankIcon from "@/components/RankIcon";
import Banners from "@/components/widgets/banners";
import {
  BarHorizontalOptions as BarHorizontalOptionsBase,
  ColumnRedeOptions as ColumnRedeOptionsBase,
  DonutListaOptions as DonutListaOptionsBase,
  DonutMesOptions as DonutMesOptionsBase,
} from "@/data/dashboards/mainData";

function cloneChartOptions(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function payload(res) {
  return res && res.data ? res.data : null;
}

export default {
  locales: {
    pt: {},
    es: {},
  },
  components: {
    Layout,
    apexchart: VueApexCharts,
    Calendar,
    RankIcon,
    Banners,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    const startDate = new Date();
    const endDate = new Date();
    endDate.setDate(startDate.getDate() + 7);
    return {
      referral: {
        sponsored: process.env.VUE_APP_URL_PAINEL + this.$store.state.account.user.username,
      },

      loadingMainCards: [true, true, true, true, true, true],
      loadingRankingLista: true,
      loadingRankingMes: true,
      loadingBarNivel: true,
      loadingRedeMes: true,
      loadingDonutLista: true,
      loadingDonutMes: true,
      dateRange: [startDate, endDate],
      MainInfoCards: [null, null, null, null, null, null],
      RankingListaData: [],
      RankingMesData: [],
      BarHorizontalSeries: [],
      BarHorizontalOptions: cloneChartOptions(BarHorizontalOptionsBase),
      ColumnRedeSeries: [],
      ColumnRedeOptions: cloneChartOptions(ColumnRedeOptionsBase),
      DonutListaSeries: [],
      DonutListaOptions: cloneChartOptions(DonutListaOptionsBase),
      DonutMesSeries: [],
      DonutMesOptions: cloneChartOptions(DonutMesOptionsBase),

      subscriptions: {
        pendings: 0,
      }
    };
  },
  mounted() {
    this.loadDashboard();
    this.getPaymentsPendings()
  },
  methods: {
    loadDashboard() {
      this.loadMainCards();
      this.loadRankingLista();
      this.loadRankingMes();
      this.loadGraficoPorNivel();
      this.loadGraficoRedePorMes();
      this.loadDonutListaAtual();
      this.loadDonutMes();
    },

    loadMainCards() {
      const cardPaths = [
        "dashboards/lista-atual",
        "dashboards/volume-mensal",
        "dashboards/faturamento-atual",
        "dashboards/faturamento-mensal",
        "dashboards/afiliados-diretos",
        "dashboards/rede-completa",
      ];
      this.loadingMainCards = [true, true, true, true, true, true];
      this.MainInfoCards = [null, null, null, null, null, null];
      cardPaths.forEach((path, index) => {
        api
          .get(path)
          .then((res) => {
            const p = payload(res);
            const card =
              p && p.status === "success" && p.data ? p.data : null;
            this.$set(this.MainInfoCards, index, card);
          })
          .catch(() => {})
          .finally(() => {
            this.$set(this.loadingMainCards, index, false);
          });
      });
    },

    loadRankingLista() {
      this.loadingRankingLista = true;
      api
        .get("dashboards/ranking-lista")
        .then((res) => {
          const pRankLista = payload(res);
          if (
            pRankLista &&
            pRankLista.status === "success" &&
            Array.isArray(pRankLista.ranking)
          ) {
            this.RankingListaData = pRankLista.ranking;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loadingRankingLista = false;
        });
    },

    loadRankingMes() {
      this.loadingRankingMes = true;
      api
        .get("dashboards/ranking-mes")
        .then((res) => {
          const pRankMes = payload(res);
          if (
            pRankMes &&
            pRankMes.status === "success" &&
            Array.isArray(pRankMes.ranking)
          ) {
            this.RankingMesData = pRankMes.ranking;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loadingRankingMes = false;
        });
    },

    loadGraficoPorNivel() {
      this.loadingBarNivel = true;
      api
        .get("dashboards/grafico-por-nivel")
        .then((res) => {
          const pBar = payload(res);
          if (pBar && pBar.status === "success") {
            this.BarHorizontalSeries = pBar.series || [];
            this.BarHorizontalOptions = {
              ...this.BarHorizontalOptions,
              xaxis: {
                ...this.BarHorizontalOptions.xaxis,
                categories: pBar.categories || [],
              },
            };
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loadingBarNivel = false;
        });
    },

    loadGraficoRedePorMes() {
      this.loadingRedeMes = true;
      api
        .get("dashboards/grafico-rede-por-mes")
        .then((res) => {
          const pCol = payload(res);
          if (pCol && pCol.status === "success") {
            this.ColumnRedeSeries = pCol.series || [];
            this.ColumnRedeOptions = {
              ...this.ColumnRedeOptions,
              xaxis: {
                ...this.ColumnRedeOptions.xaxis,
                categories: pCol.categories || [],
              },
            };
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loadingRedeMes = false;
        });
    },

    loadDonutListaAtual() {
      this.loadingDonutLista = true;
      api
        .get("dashboards/donut-lista-atual")
        .then((res) => {
          const pDonutLista = payload(res);
          if (pDonutLista && pDonutLista.status === "success") {
            this.DonutListaSeries = pDonutLista.series || [];
            this.DonutListaOptions = {
              ...this.DonutListaOptions,
              labels: pDonutLista.labels || [],
            };
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loadingDonutLista = false;
        });
    },

    loadDonutMes() {
      this.loadingDonutMes = true;
      api
        .get("dashboards/donut-mes")
        .then((res) => {
          const pDonutMes = payload(res);
          if (pDonutMes && pDonutMes.status === "success") {
            this.DonutMesSeries = pDonutMes.series || [];
            this.DonutMesOptions = {
              ...this.DonutMesOptions,
              labels: pDonutMes.labels || [],
            };
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loadingDonutMes = false;
        });
    },

    getPaymentsPendings() {
      api.get("subscriptions/pendings").then((response) => {
        if (response.data.status == 'success') {
          this.subscriptions.pendings = response.data.total;
        }
      });
    }
  },
};
</script>

<template>
  <Layout>
    <router-link tag="a" to="/subscriptions" v-if="subscriptions.pendings > 0">
      <div class="bg-soft-danger p-3 rounded mb-3 d-flex align-items-center">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"></path><path d="M11 10h2v5h-2zm0 6h2v2h-2z"></path></svg>
        </div>
        <div class="ml-3">
          <h5 class="mb-0">Atenção!</h5>
          <p class="mb-0 text-dark">Você possui <strong class="font-size-16">{{ subscriptions.pendings }}</strong> mensalidade(s) pendente(s).</p>
          <p class="mb-0 text-dark">Clique aqui para realizar o pagamento.</p>
        </div>
      </div>
    </router-link>

    <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-gap-10">
      <div>
        <h1 class="mb-0 font-size-20 font-weight-bold">Painel</h1>
      </div>
      <div class="d-none align-items-center flex-wrap flex-gap-10">
        <div class="form-group mb-0 dashboards-calendar-wrap">
          <Calendar
            v-model="dateRange"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            placeholder="Buscar por período"
            class="dashboards-calendar"
          />
        </div>
        <div class="d-flex flex-gap-10">
          <button type="button" class="btn btn-primary btn-sm" @click="loadDashboard">
            <i class="bx bx-refresh"></i>
          </button>
          <button type="button" class="btn btn-primary btn-sm">
            <i class="bx bx-filter-alt"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body p-1 d-flex justify-content-between align-items-center">
        <div class="mr-2">
          <div class="bg-light rounded p-2">
            <i class="bx bx-link-alt font-size-24 align-middle"></i>
          </div>
        </div>
        <h5 class="flex-fill m-0 align-items-center font-size-16">
          Link de afiliado
        </h5>
        <div class="d-flex align-items-center">
          <div class="ml-1">
            <ShareNetwork network="whatsapp" url="" :title="referral.sponsored" class="text-dark">
              <div class="bg-light rounded p-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 0 0 4.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 0 0-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 0 1-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 0 1-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 0 0-.429-.008.826.826 0 0 0-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263">
                  </path>
                </svg>
              </div>
            </ShareNetwork>
          </div>
          <div class="ml-1">
            <button class="btn btn-link p-0 m-0 text-dark" v-clipboard:copy="referral.sponsored
              " v-on:click="$toast.success('Copiado!');">
              <div class="bg-light rounded p-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
                  <path
                    d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z">
                  </path>
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div
        v-for="(isCardLoading, cardIndex) in loadingMainCards"
        :key="'main-card-' + cardIndex"
        class="col-xl-4 col-lg-4 col-md-6 mb-3"
      >
        <div v-if="isCardLoading" class="card h-100">
          <div class="card-body pb-0">
            <div class="skeleton-line sk-w-50 mb-2"></div>
            <div class="skeleton-line sk-w-75 mb-2 skeleton-lg"></div>
            <div class="skeleton-line sk-w-60 mb-3"></div>
            <div class="skeleton-line sk-w-100 skeleton-sm"></div>
          </div>
        </div>
        <div v-else-if="MainInfoCards[cardIndex]" class="card h-100">
          <div class="card-body pb-0">
            <span class="font-size-13 font-weight-medium d-block mb-1 text-muted">{{
              MainInfoCards[cardIndex].title
            }}</span>
            <h4 class="font-weight-bold mb-1 dashboards-metric">{{ MainInfoCards[cardIndex].count }}</h4>
            <p class="text-muted font-size-12 mb-2">
              {{ MainInfoCards[cardIndex].secondaryValue }}
              <span
                v-if="MainInfoCards[cardIndex].percent"
                :class="
                  MainInfoCards[cardIndex].percentPositive ? 'text-success' : 'text-danger'
                "
              >
                {{ MainInfoCards[cardIndex].percent }}
              </span>
            </p>
            <div
              class="progress dashboards-progress"
              role="progressbar"
              :aria-valuenow="MainInfoCards[cardIndex].progress"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              <div
                :class="'progress-bar bg-success'"
                :style="{ width: MainInfoCards[cardIndex].progress + '%' }"
              ></div>
            </div>
          </div>
        </div>
        <div v-else class="card h-100">
          <div
            class="card-body pb-0 d-flex align-items-center justify-content-center"
            style="min-height: 120px"
          >
            <span class="text-muted font-size-13 mb-0">Dados indisponíveis.</span>
          </div>
        </div>
      </div>
    </div>

    <Banners></Banners>

    <div class="row">
      <div class="col-xl-6 mb-3">
        <div class="card">
          <div class="card-header bg-transparent border-bottom">
            <h4 class="card-title mb-0 font-size-16 font-weight-bold">Ranking Lista Atual</h4>
          </div>
          <div class="card-body p-0">
            <ul class="list-unstyled ranking-list mb-0">
              <template v-if="loadingRankingLista">
                <li
                  v-for="n in 5"
                  :key="'sk-rank-lista-' + n"
                  class="d-flex align-items-center flex-gap-10 py-2 px-3"
                >
                  <div class="skeleton-circle-sm" style="min-width: 24px"></div>
                  <div class="skeleton-circle" style="width:26px;height:26px;min-width:26px;border-radius:50%"></div>
                  <div class="skeleton-avatar"></div>
                  <div class="skeleton-line flex-fill mb-0"></div>
                  <div class="skeleton-line sk-w-60px mb-0"></div>
                </li>
              </template>
              <template v-else>
                <li
                  v-for="(item, index) in RankingListaData"
                  :key="index"
                  :class="[
                    'd-flex align-items-center flex-gap-10 py-2 px-3',
                    item.highlighted ? 'bg-soft-primary border-top border-bottom' : '',
                  ]"
                >
                  <span class="font-weight-bold text-muted" style="min-width: 24px">
                    {{ item.position }}
                  </span>
                  <rank-icon :type="item.type" :size="26" />
                  <img
                    v-if="item.avatarUrl"
                    :src="item.avatarUrl"
                    class="avatar-sm rounded-circle"
                    alt=""
                  />
                  <span
                    v-else
                    :class="'avatar-sm rounded-circle text-white d-inline-flex align-items-center justify-content-center font-size-12 ' + item.avatarClass"
                  >
                    {{ item.initials }}
                  </span>
                  <div class="flex-fill">
                    <span class="d-block font-weight-bold">{{ item.name }}</span>
                  </div>
                  <span class="font-weight-bold">{{ item.value }}</span>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-xl-6 mb-3">
        <div class="card">
          <div class="card-header bg-transparent border-bottom">
            <h4 class="card-title mb-0 font-size-16 font-weight-bold">Ranking Mês</h4>
          </div>
          <div class="card-body p-0">
            <ul class="list-unstyled ranking-list mb-0">
              <template v-if="loadingRankingMes">
                <li
                  v-for="n in 5"
                  :key="'sk-rank-mes-' + n"
                  class="d-flex align-items-center flex-gap-10 py-2 px-3"
                >
                  <div class="skeleton-circle-sm" style="min-width: 24px"></div>
                  <div class="skeleton-circle" style="width:26px;height:26px;min-width:26px;border-radius:50%"></div>
                  <div class="skeleton-avatar"></div>
                  <div class="skeleton-line flex-fill mb-0"></div>
                  <div class="skeleton-line sk-w-60px mb-0"></div>
                </li>
              </template>
              <template v-else>
                <li
                  v-for="(item, index) in RankingMesData"
                  :key="index"
                  :class="[
                    'd-flex align-items-center flex-gap-10 py-2 px-3',
                    item.highlighted ? 'bg-soft-primary border-top border-bottom' : '',
                  ]"
                >
                  <span class="font-weight-bold text-muted" style="min-width: 24px">
                    {{ item.position }}
                  </span>
                  <rank-icon :type="item.type" :size="26" />
                  <img
                    v-if="item.avatarUrl"
                    :src="item.avatarUrl"
                    class="avatar-sm rounded-circle"
                    alt=""
                  />
                  <span
                    v-else
                    :class="'avatar-sm rounded-circle text-white d-inline-flex align-items-center justify-content-center font-size-12 ' + item.avatarClass"
                  >
                    {{ item.initials }}
                  </span>
                  <div class="flex-fill">
                    <span class="d-block font-weight-bold">{{ item.name }}</span>
                  </div>
                  <span class="font-weight-bold">{{ item.value }}</span>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6 col-lg-6 mb-3">
        <div class="card">
          <div class="card-header bg-transparent border-bottom">
            <h4 class="card-title mb-0 font-size-16 font-weight-bold">Rede por Nível</h4>
          </div>
          <div class="card-body">
            <div v-if="loadingBarNivel" class="skeleton-chart" style="height: 320px"></div>
            <apexchart
              v-else
              height="320"
              type="bar"
              :options="BarHorizontalOptions"
              :series="BarHorizontalSeries"
            />
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 mb-3">
        <div class="card">
          <div class="card-header bg-transparent border-bottom">
            <h4 class="card-title mb-0 font-size-16 font-weight-bold">Rede por Mês</h4>
          </div>
          <div class="card-body">
            <div v-if="loadingRedeMes" class="skeleton-chart" style="height: 320px"></div>
            <apexchart
              v-else
              height="320"
              type="bar"
              :options="ColumnRedeOptions"
              :series="ColumnRedeSeries"
            />
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 mb-3">
        <div class="card">
          <div class="card-header bg-transparent border-bottom">
            <h4 class="card-title mb-0 font-size-16 font-weight-bold">
              Representatividade por Nível <sup class="font-weight-light">lista atual</sup>
            </h4>
          </div>
          <div class="card-body">
            <div
              v-if="loadingDonutLista"
              class="skeleton-donut-wrap d-flex align-items-center justify-content-center"
              style="height: 290px"
            >
              <div class="skeleton-donut"></div>
            </div>
            <apexchart
              v-else
              height="290"
              type="donut"
              :options="DonutListaOptions"
              :series="DonutListaSeries"
            />
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 mb-3">
        <div class="card">
          <div class="card-header bg-transparent border-bottom">
            <h4 class="card-title mb-0 font-size-16 font-weight-bold">
              Representatividade por Nível <sup class="font-weight-light">mês</sup>
            </h4>
          </div>
          <div class="card-body">
            <div
              v-if="loadingDonutMes"
              class="skeleton-donut-wrap d-flex align-items-center justify-content-center"
              style="height: 290px"
            >
              <div class="skeleton-donut"></div>
            </div>
            <apexchart
              v-else
              height="290"
              type="donut"
              :options="DonutMesOptions"
              :series="DonutMesSeries"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.main-dashboard-banner {
  background: linear-gradient(
    135deg,
    rgba(220, 80, 60, 0.95) 0%,
    rgba(180, 40, 30, 0.95) 50%,
    rgba(140, 20, 10, 0.95) 100%
  );
  border: none;
}

.main-banner-title {
  font-size: 2rem;
  color: #fff;
  text-shadow:
    0 0 10px rgba(255, 150, 50, 0.8),
    0 0 20px rgba(255, 100, 50, 0.6),
    0 0 30px rgba(255, 80, 30, 0.4);
  letter-spacing: 0.02em;
}

.main-banner-subtitle {
  color: rgba(255, 255, 255, 0.95);
}

.ranking-list li {
  border-bottom: 1px solid #e9ecef;
}

.ranking-list li:last-child {
  border-bottom: none;
}

.dashboards-progress {
  height: 6px;
}

.dashboards-metric {
  font-size: 1.35rem;
}

.dashboards-calendar-wrap {
  min-width: 220px;
}

.dashboards-calendar >>> .p-calendar {
  width: 100%;
}

.dashboards-calendar >>> .p-inputtext {
  width: 100%;
}

/* Placeholders de carregamento (shimmer) */
.skeleton-line,
.skeleton-avatar,
.skeleton-circle-sm,
.skeleton-chart,
.skeleton-donut {
  background: linear-gradient(
    90deg,
    #e8e8e8 25%,
    #f5f5f5 50%,
    #e8e8e8 75%
  );
  background-size: 200% 100%;
  animation: dashboards-shimmer 1.4s infinite ease-in-out;
  border-radius: 4px;
}

.skeleton-line {
  height: 14px;
  margin-bottom: 6px;
}

.skeleton-line.skeleton-lg {
  height: 22px;
}

.skeleton-line.skeleton-sm {
  height: 6px;
  margin-bottom: 0;
}

.skeleton-line.mb-0 {
  margin-bottom: 0;
}

.skeleton-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  flex-shrink: 0;
}

.skeleton-circle-sm {
  width: 24px;
  height: 16px;
  border-radius: 3px;
  flex-shrink: 0;
}

.skeleton-line.skeleton-icon-placeholder {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  flex-shrink: 0;
}

.skeleton-chart {
  border-radius: 8px;
  width: 100%;
}

.skeleton-donut {
  width: 180px;
  height: 180px;
  border-radius: 50%;
}

.sk-w-50 {
  width: 50%;
}

.sk-w-60 {
  width: 60%;
}

.sk-w-75 {
  width: 75%;
}

.sk-w-100 {
  width: 100%;
}

.sk-w-60px {
  width: 60px;
}

@keyframes dashboards-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Tema escuro: tons mais claros para contraste */
body[data-sidebar="dark"] .skeleton-line,
body[data-sidebar="dark"] .skeleton-avatar,
body[data-sidebar="dark"] .skeleton-circle-sm,
body[data-sidebar="dark"] .skeleton-chart,
body[data-sidebar="dark"] .skeleton-donut {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.08) 25%,
    rgba(255, 255, 255, 0.14) 50%,
    rgba(255, 255, 255, 0.08) 75%
  );
  background-size: 200% 100%;
}
</style>
